import {Injectable, inject} from '@angular/core'
import {ConfigAgent} from '@models/configAgent'
import {Configuration} from '@models/configuration'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {ConfigurationService} from './configuration.service'

/**
 * Variante embebida del `ConfigurationService`.
 *
 * @description
 * Sobrescribe los métodos de `ConfigurationService` para que la configuración provenga
 * del `EmbeddedStoreService` (enviada por la aplicación anfitriona) en lugar de PouchDB.
 * En modo embebido no se persisten cambios locales: `saveConfiguracion` es un no-op y
 * `getConfiguration` devuelve `null`.
 *
 * @usageNotes
 *
 * ### Bad Uses / Errores comunes
 * - Inyectar esta clase directamente en servicios de dominio: el contenedor DI se encarga
 *   de resolver la implementación correcta según el modo (standalone/embebido).
 */
@Injectable({
  providedIn: 'root',
})
export class ConfigurationEmbeddedService extends ConfigurationService {
  private readonly embeddedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)

  /** Devuelve el `ConfigAgent` enviado por la app anfitriona vía `EmbeddedStoreService`. */
  override getConfigAgent = async (): Promise<ConfigAgent> => {
    return this.embeddedStoreService.configAgent()
  }

  /** En modo embebido no hay configuración local persistida. */
  override getConfiguration = (): Promise<Configuration> => {
    return null
  }

  /** No-op: los cambios de configuración son responsabilidad del host embebido. */
  override saveConfiguracion = (configuration: Configuration): void => {}
}
